import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoTab from 'eco-design/elements/eco-tab';
import EcoImg from 'eco-design/base/eco-img';
import { Navigation } from 'swiper';
import type SwiperType from 'swiper';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const TabImgs: React.FC = () => {
    const { t } = useLang('theProductV2.TabImgs');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-TabImgs-V2');

    const items = [
        {
            tabLabel: t('tab1'),
            tabValue: '0',
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272964216/1-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707650297/1-pc.webp',
            ),
            pad: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272964216/1-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707650297/1-pc.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272964785/1-h5.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707649423/1-h5.webp',
            ),
        },
        {
            tabLabel: t('tab2'),
            tabValue: '1',
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272965575/2-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707649618/2-pc.webp',
            ),
            pad: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272965575/2-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707649618/2-pc.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272964436/2-h5.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707649870/2-h5.webp',
            ),
        },
        {
            tabLabel: t('tab3'),
            tabValue: '3',
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272965139/3-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707650938/3-pc.webp',
            ),
            pad: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272965139/3-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707650938/3-pc.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761272964051/3-h5.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761707650517/3-h5.webp',
            ),
        },
    ];

    const swiperRef = useRef<SwiperType | null>(null);
    const [activeKey, setActiveKey] = useState(items[0].tabValue);
    const [activeIndex, setActiveIndex] = useState(0);
    const handleTabClick = (key: string, idx: number) => {
        setActiveKey(key);
        setActiveIndex(idx);
        swiperRef.current?.slideToLoop(items.findIndex((i) => i.tabValue === key));
    };

    // 埋点
    const handleGtm = (type: 'left' | 'right') => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('title') || 'none',
            button_name: type === 'left' ? 'Left switch' : 'Right switch',
            __btn_id1: `rapid-mag-TabImgs-V2 .img-swiper-${type}`,
            __btn_id2: `${type === 'left' ? '<' : '>'}`,
            __btn_type: 'text',
        });
    };
    return (
        <section
            className={`GtmModuleData-section ${css.comp}`}
            id="rapid-mag-TabImgs-V2"
            data-section-id={'rapid-mag-TabImgs-V2'}
            data-section-title={t('title')}
        >
            <EcoTitle title={t('title')} />
            <EcoSpaceSmall />
            <div className="img-swiper-box">
                <Swiper
                    className="img-swiper"
                    onSwiper={(swiper) => (swiperRef.current = swiper)} // 获取实例
                    navigation={{
                        nextEl: '.img-swiper-right',
                        prevEl: '.img-swiper-left',
                    }}
                    modules={[Navigation]}
                    onTransitionEnd={(e) => {
                        setActiveIndex(e.activeIndex);
                        setActiveKey(items[e.activeIndex].tabValue);
                    }}
                >
                    {items.map((item) => (
                        <SwiperSlide className="img-item" key={item.tabLabel}>
                            <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className={`img-swiper-left GtmModuleData-btn-text`} onClick={() => handleGtm('left')}>
                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                </div>
                <div className={`img-swiper-right GtmModuleData-btn-text`} onClick={() => handleGtm('right')}>
                    <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                </div>
            </div>

            <EcoTab items={items} activeIndex={activeIndex} activeKey={activeKey} onChange={(item, idx) => handleTabClick(item.tabValue, idx)} />
        </section>
    );
};
export default TabImgs;
